import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import "./dashboard.css";
import { getMonthlyExpenseDashboard, getMonthlyRevenueDashboard, getTodayCountsDashboard, getVisitsByCategoryDashboard } from "../api/reportsAPI";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const AdminDashboard = () => {
  
    const [thisMonthRevenue, setThisMonthRevenue] = useState(0);
    const [monthlyData, setMonthlyData] = useState([0,0,0,0,0]);
    const [monthlyCategories, setMonthlyCategories] = useState(["2000-01", "2000-02", "2000-03", "2000-04", "2000-05"]);
    
    const [thisMonthExpense, setThisMonthExpense] = useState(0);
    const [monthlyDataExpense, setMonthlyDataExpense] = useState([0,0,0,0,0]);
    const [monthlyCategoriesExpense, setMonthlyCategoriesExpense] = useState(["2000-01", "2000-02", "2000-03", "2000-04", "2000-05"]);
    
    const [monthlyCounts, setMonthlyCounts] = useState([0,0]);
    const [monthlyCountsCategories, setMonthlyCountsCategories] = useState(["Physio", "Nursing"]);    
    const [todayCounts, setTodayCounts] = useState(null);
    

    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    useEffect( async () => {
      // let visits = await getVisitCountsDashboard();
      // if (visits && visits.data && visits.data.length > 0) {
      //   setVisitCounts(visits.data[0])
      // }          
      await loadMonthlyRevenue()
      await loadMonthlyExpense()
      await loadVisitsByCategory()
      await loadTodayCounts()
    }, [dispatch]);

    const loadMonthlyRevenue = async () => {
      let visits = await getMonthlyRevenueDashboard();
      if (visits && visits.data && visits.data.length > 0) {
        //console.log('visits',visits.data)
        let monthlyDataArray = []
        let monthlyCategoryArray = []
        for (let index = 0; index < visits.data.length; index++) {
          const element = visits.data[index];
          monthlyDataArray.push(element?.amount);
          monthlyCategoryArray.push(element?.pay_month);  
          if(moment().format('YYYY-MM') === moment(element?.pay_month).format('YYYY-MM')){
            setThisMonthRevenue(element?.amount)
          }        
        }  
        setMonthlyData(monthlyDataArray)    
        setMonthlyCategories(monthlyCategoryArray)    
      } 
    }

    const loadMonthlyExpense = async () => {
      let visits = await getMonthlyExpenseDashboard();
      if (visits && visits.data && visits.data.length > 0) {
        //console.log('visits',visits.data)
        let monthlyDataArray = []
        let monthlyCategoryArray = []
        for (let index = 0; index < visits.data.length; index++) {
          const element = visits.data[index];
          monthlyDataArray.push(element?.amount);
          monthlyCategoryArray.push(element?.expense_month);  
          if(moment().format('YYYY-MM') === moment(element?.expense_month).format('YYYY-MM')){
            setThisMonthExpense(element?.amount)
          }        
        }  
        setMonthlyDataExpense(monthlyDataArray)    
        setMonthlyCategoriesExpense(monthlyCategoryArray)    
      } 
    }

    const loadVisitsByCategory = async () => {
        let visits = await getVisitsByCategoryDashboard();
        if (visits && visits.data && visits.data.length > 0) {
          let monthlyCountsArray = []
          let monthlyCountsCategoryArray = []
          for (let index = 0; index < visits.data.length; index++) {
            const element = visits.data[index];
            monthlyCountsArray.push(element?.counts);
            monthlyCountsCategoryArray.push(element?.service_name);  
                  
          }  
          setMonthlyCounts(monthlyCountsArray)    
          setMonthlyCountsCategories(monthlyCountsCategoryArray)    
        } 
      }

      const loadTodayCounts = async () => {
        let visits = await getTodayCountsDashboard();
        if (visits && visits.data && visits.data.length > 0) {
          setTodayCounts(visits.data[0]) 
        } 
      }

  // Monthly Revenue (Line Chart)
  const revenueChart = {
    series: [
      {
        name: "Revenue",
        data: monthlyData
      }
    ],
    options: {
      chart: {
        type: "line",
        toolbar: { show: false }
      },
      colors: ["#2F80ED"],
      xaxis: {
        categories: monthlyCategories
      },
      stroke: {
        curve: "smooth",
        width: 3
      },
      dataLabels: { enabled: false }
    }
  };

  // Monthly Expense (Line Chart)
  const expenseChart = {
    series: [
      {
        name: "Expense",
        data: monthlyDataExpense
      }
    ],
    options: {
      chart: {
        type: "line",
        toolbar: { show: false }
      },
      colors: ["#eb5c2bfc"],
      xaxis: {
        categories: monthlyCategoriesExpense
      },
      stroke: {
        curve: "smooth",
        width: 3
      },
      dataLabels: { enabled: false }
    }
  };

  // Visits by Service Type (Donut)
  const serviceChart = {
    series: monthlyCounts,//[45, 30, 25],
    options: {
      labels: monthlyCountsCategories, //["Physiotherapy", "Home Nursing", "Elderly Care"],
      colors: ["#27AE60", "#2F80ED", "#F2994A"],
      legend: {
        position: "bottom"
      }
    }
  };

  // Users Growth (Bar Chart)
  const usersChart = {
    series: [
      {
        name: "Patients",
        data: [40, 55, 70, 90, 120]
      },
      {
        name: "Nurses",
        data: [10, 15, 20, 28, 35]
      }
    ],
    options: {
      chart: {
        type: "bar",
        toolbar: { show: false }
      },
      colors: ["#56CCF2", "#27AE60"],
      plotOptions: {
        bar: {
          borderRadius: 6,
          columnWidth: "45%"
        }
      },
      xaxis: {
        categories: ["Jan", "Feb", "Mar", "Apr", "May"]
      }
    }
  };

  return (
    <div className="dashboard">
      {/* <h2>Admin Dashboard</h2> */}

      {/* Summary Cards */}
      <div className="cards">
        <div className="card">👥 Total Patients: {Number(todayCounts?.patientsCount ?? 0).toLocaleString()}</div>
        <div className="card">🧑‍⚕️ Nurses: {Number(todayCounts?.nurseCounts ?? 0).toLocaleString()}</div>
        <div className="card">📅 Today’s Visits: {Number(todayCounts?.visitsCounts ?? 0).toLocaleString()}</div>
        <div className="card">💰 Monthly Revenue: {Number(thisMonthRevenue).toLocaleString()}</div>
        <div className="card">💰 Monthly Expense: {Number(thisMonthExpense).toLocaleString()}</div>
      </div>

      {/* Charts */}
      <div className="charts">

        <div className="chart-card">
          <h3>Monthly Revenue</h3>
          <Chart
            options={revenueChart.options}
            series={revenueChart.series}
            type="line"
            height={300}
          />
        </div>

        <div className="chart-card">
          <h3>Visits by Service</h3>
          <Chart
            options={serviceChart.options}
            series={serviceChart.series}
            type="donut"
            height={300}
          />
        </div>

        <div className="chart-card">
          <h3>Monthly Expense</h3>
          <Chart
            options={expenseChart.options}
            series={expenseChart.series}
            type="line"
            height={300}
          />
        </div>

        {/* <div className="chart-card">
          <h3>User Growth</h3>
          <Chart
            options={usersChart.options}
            series={usersChart.series}
            type="bar"
            height={300}
          />
        </div> */}

      </div>
    </div>
  );
};

export default AdminDashboard;
